import React from "react";
import { MdChat } from "react-icons/md";
import { MdEmail } from "react-icons/md";
import { IoMdLink } from "react-icons/io";
import { GoHash } from "react-icons/go";
import { FaPhone } from "react-icons/fa";
import { TextQuestionTypes } from "survey";
import { InputLabel } from "components/atoms";

const textQuestionTypeOptions: {
  name: string;
  value: TextQuestionTypes;
  icon: JSX.Element;
}[] = [
  { name: "Tekst", value: "text", icon: <MdChat /> },
  { name: "Email", value: "email", icon: <MdEmail /> },
  { name: "Url", value: "url", icon: <IoMdLink /> },
  { name: "Numer", value: "number", icon: <GoHash /> },
  { name: "Telefon", value: "phone", icon: <FaPhone /> },
];

interface TextQuestionTypeSwitchProps {
  currentType: TextQuestionTypes;
  onChange: (type: TextQuestionTypes) => void;
}
export const TextQuestionTypeSwitch = ({ currentType, onChange }: TextQuestionTypeSwitchProps) => {
  return (
    <div className="">
      <InputLabel name="kind" label="Rodzaj danych" />
      <div className="flex items-center">
        <div className="grid w-full grid-cols-2 gap-1 rounded-md border border-slate-300 p-1 sm:flex sm:items-center sm:justify-between dark:border-slate-600">
          {textQuestionTypeOptions.map((option) => (
            <div
              key={option.value}
              onClick={() => onChange(option.value)}
              className={`flex-grow cursor-pointer rounded-md p-2 text-center ${
                currentType === option.value ? "bg-slate-100 dark:bg-slate-600 " : ""
              }`}
            >
              <div className="flex items-center justify-center space-x-2">
                <span className="text-sm text-slate-900 dark:text-slate-200">{option.name}</span>
                <div className="h-4 w-4 text-slate-600 hover:text-slate-800 dark:text-slate-200 dark:hover:text-white">
                  {option.icon}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
